<div class="tabbable__body rounded-top-right no-margin">
    <h3>
      Här kan du administrera estimatfördelning för placeringar
    </h3>

  @if (show.estimatesHaveChanged) {
    <div class="tabbable__body">
      <import-warning></import-warning>
      <dot-loader [visibility]="show.updatingEstimates"></dot-loader>
    </div>
  }

  <div class="container">
    <div class="left-item">
      @if (show.isEditing) {
        <button
          class="button primary" (click)="save()" [disabled]="agWithdrawalLimits.invalid">
          Spara
        </button>
        <button class="link" (click)="cancelEditing()">
          Avbryt redigering
        </button>
      } @else {
        <button class="button primary" (click)="setEditing(true)">
          Redigera Placeringar
        </button>
      }
      </div>
      <div class="right-item">
        @if (publishers?.length > 1) {
          <div class="filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="publishers"
              [(ngModel)]="selectedPublisher"
              name="selectedPublisher"
              inputId="select-publisher"
              labelText="Välj Publicist"
              notFoundText="Inga publicister hittades."
            ></woo-dropdown>
          </div>
        }
      </div>
  </div>
  <div class="sticky-header">
    <h3>Estimatfördelning för placeringar</h3>
  </div>


  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #agWithdrawalLimits="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-center" colspan="3">Estimatfördelning</th>
        <th class="text-center" colspan="3">Maxuttag</th>
      </tr>
      <tr>
        @for (header of tableHeaders; let index = $index; track index) {
          <th class="text--thin capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (
        row of ProductFormatRow;
        let index = $index;
        track row
      ) {
        <tr [hidden]="!rowVisible(row)">
          <td class="text--thin vertical-align--middle">
            <span>{{ row.publisher }}</span>
          </td>
          <td class="text--thin vertical-align--middle">
            <span>{{ translateProductFormat(row.productFormat) }}</span>
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.sharesPreroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesPreroll"
                  [(ngModel)]="
                    getProductFormat(row.productFormatId)
                      .product_format_shares.preroll
                  "
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="
                    includedProductFormatSlotTypes[row.productFormatId].preroll
                  "
                  [disabled]="
                    !includedProductFormatSlotTypes[row.productFormatId].preroll
                  "
                  (ngModelChange)="autoFill(row, 'preroll')"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.sharesMidroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesMidroll"
                  [(ngModel)]="
                    getProductFormat(row.productFormatId)
                      .product_format_shares.midroll
                  "
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="
                    includedProductFormatSlotTypes[row.productFormatId].midroll
                  "
                  [disabled]="true"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.sharesPostroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesPostroll"
                  [(ngModel)]="
                    getProductFormat(row.productFormatId)
                      .product_format_shares.postroll
                  "
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="
                    includedProductFormatSlotTypes[row.productFormatId].postroll
                  "
                  [disabled]="
                    !includedProductFormatSlotTypes[row.productFormatId]
                      .postroll
                  "
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.withdrawalLimitsPreroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-withdrawalLimitesPreroll"
                  [(ngModel)]="
                    getProductFormat(row.productFormatId)
                      .withdrawal_limits.preroll
                  "
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="
                    includedProductFormatSlotTypes[row.productFormatId].preroll
                  "
                  [disabled]="
                    !includedProductFormatSlotTypes[row.productFormatId]
                      .preroll
                  "
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.withdrawalLimitsMidroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-withdrawalLimitesMidroll"
                  [(ngModel)]="
                    getProductFormat(row.productFormatId)
                      .withdrawal_limits.midroll
                  "
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="
                    includedProductFormatSlotTypes[row.productFormatId].midroll
                  "
                  [disabled]="
                    !includedProductFormatSlotTypes[row.productFormatId]
                      .midroll
                  "
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.withdrawalLimitsPostroll | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-withdrawalLimitesPostroll"
                  [(ngModel)]="
                    getProductFormat(row.productFormatId)
                      .withdrawal_limits.postroll
                  "
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="
                    includedProductFormatSlotTypes[row.productFormatId].postroll
                  "
                  [disabled]="
                    !includedProductFormatSlotTypes[row.productFormatId]
                      .postroll
                  "
                />
              </div>
            }
          </td>
        </tr>
      }

      <tr>
        <td class="vertical-align--middle">
          <strong>Totalt:</strong>
        </td>
        <td></td>
        @if (productFormats) {
          @for (slotType of slotTypes; track slotType) {
            <td>
              @if (sumOfProductFormatShares(slotType) !== 0) {
                <span>
                  <strong>
                    {{ sumOfProductFormatShares(slotType) }}
                  </strong>
                  %
                </span>
              }
            </td>
          }
          <td colspan="3"></td>
        }
      </tr>
    </tbody>
  </table>

  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  @if (show.isEditing) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="save()"
        [disabled]="agWithdrawalLimits.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">
        Avbryt redigering
      </button>
    </div>
  }
</div>

